import {IconButton} from '@mui/material';

import styled from 'styled-components';

const StyledIconButton = styled(IconButton)`
	margin-left: auto !important;
	padding: 0;
`;

export {StyledIconButton};
